<div class="lpr-source-dropdown">
  <ng-container
    *ngIf="{
      isVisible: isSourcesDropdownVisible$ | async,
      areProvidersEmpty: areProvidersEmpty$ | async,
      hasAllSelected: hasAllSourcesSelected$ | async,
      selectedCount: selectedSourcesCount$ | async,
      areAllLoaded: lprSourceSelectService.areAllProvidersLoaded$ | async,
      totalResults: totalResults$ | async,
      isDisabled: isDisabled
    } as dropdown"
  >
    <fieldset
      #sourceDisplay
      class="lpr-source-dropdown__source-display lpr-source-dropdown__source-display--hover"
      [class.lpr-source-dropdown__source-display--dropdown-visible]="dropdown.isVisible"
      [class.lpr-source-dropdown__source-display--disabled]="dropdown.areProvidersEmpty || dropdown.isDisabled"
      (click)="setSourcesDropdownVisibility(true)"
      data-testid="source-select-dropdown"
    >
      <legend class="lpr-source-dropdown__source-display-label">{{ 'common.source' | t }}</legend>

      <div class="lpr-source-dropdown__source-display-container">
        <div class="lpr-source-dropdown__source-display-all-sources-count">
          <span *ngIf="dropdown.hasAllSelected" class="lpr-source-dropdown__all-sources">
            {{ 'vehicleIntelligence.alprSearch.sourceSelect.allResults' | t }}
          </span>

          <span class="lpr-source-dropdown__sources-count">
            <span *ngIf="dropdown.hasAllSelected">(</span>
            {{ dropdown.areProvidersEmpty ? 0 : dropdown.selectedCount ?? 0 }}
            {{
              ((dropdown.selectedCount ?? 0) === 1
                ? 'vehicleIntelligence.alprSearch.sourceSelect.sourceCount'
                : 'vehicleIntelligence.alprSearch.sourceSelect.sourcesCount'
              ) | t
            }}
            <span *ngIf="dropdown.hasAllSelected">)</span>
          </span>
        </div>

        <div class="lpr-source-dropdown__all-results-count">
          <span *ngIf="dropdown.areAllLoaded" class="lpr-source-dropdown__results-count" data-testid="source-select-dropdown-results-count">
            {{
              (dropdown.totalResults ?? 0) > maxTotalResults
                ? maxTotalResults + '+'
                : dropdown.totalResults ?? 0
            }}
            {{
              ((dropdown.totalResults ?? 0) === 1
                ? 'vehicleIntelligence.alprSearch.sourceSelect.resultCount'
                : 'vehicleIntelligence.alprSearch.sourceSelect.resultsCount'
              ) | t
            }}
          </span>

          <mat-spinner *ngIf="!dropdown.areAllLoaded" diameter="20"></mat-spinner>

          <sn-icon
            class="lpr-source-dropdown__menu-arrow-icon"
            fontIcon="fa-caret-down"
            fontSet="fa"
          ></sn-icon>
        </div>
      </div>

      <div
        class="lpr-source-dropdown__content lpr-source-dropdown__content--hidden"
        [class.lpr-source-dropdown__content--visible]="isSourcesDropdownVisible$ | async"
        fsClickOutside
        [fsClickOutsideIgnoredElements]="[sourceDisplay]"
        (fsClickOutside)="setSourcesDropdownVisibility(false)"
        data-testid="source-select-dropdown-content"
      >
        <!-- Axon VI-->
        <ng-container *ngIf="lprSourceSelectService.axonVIProvider$ | async">
          <fs-lpr-source-dropdown-entry
            [providerNameTranslationKey]="'vehicleIntelligence.alprSearch.sourceSelect.allAxon'"
            [provider$]="lprSourceSelectService.axonVIProvider$"
            [isProviderLoaded$]="lprSourceSelectService.isAxonVIProviderLoaded$"
            [cameraVendor$]="lprSourceSelectService.axonCameraVendor$"
            [cameraModels$]="lprSourceSelectService.axonCameraModels$"
            [shouldShowPartialMatches$]="shouldShowPartialMatches$"
            (providerSelectionChange)="providerSelection$.next($event)"
            (cameraModelSelectionChange)="cameraModelSelection$.next($event)"
            data-testid="source-dropdown-entry-axon-vi"
          ></fs-lpr-source-dropdown-entry>

          <div
            *ngIf="!(isLastProvider(ViLPRProvider.AXON_VI) | async)"
            class="lpr-source-dropdown-entry__provider-group-separator"
          ></div>
        </ng-container>

        <!-- Works with Axon -->
        <ng-container
          *ngIf="
            (lprSourceSelectService.axonVIProvider$ | async) && (shouldShowWorksWithAxon$ | async)
          "
        >
          <fs-lpr-source-dropdown-entry
            [isWorksWithAxon]="true"
            [providerNameTranslationKey]="
              'vehicleIntelligence.alprSearch.sourceSelect.worksWithAxon'
            "
            [provider$]="lprSourceSelectService.axonVIProvider$"
            [isProviderLoaded$]="lprSourceSelectService.isAxonVIProviderLoaded$"
            [count$]="lprSourceSelectService.worksWithAxonCount$"
            [cameraModels$]="lprSourceSelectService.worksWithAxonCameraModels$"
            [shouldShowPartialMatches$]="shouldShowPartialMatches$"
            (providerSelectionChange)="providerSelection$.next($event)"
            (cameraModelSelectionChange)="cameraModelSelection$.next($event)"
            data-testid="source-dropdown-entry-works-with-axon"
          >
          </fs-lpr-source-dropdown-entry>

          <div
            *ngIf="!(isLastProvider(ViLPRProvider.AXON_VI) | async)"
            class="lpr-source-dropdown-entry__provider-group-separator"
          ></div>
        </ng-container>

        <!-- Vigilant -->
        <ng-container *ngIf="lprSourceSelectService.vigilantProvider$ | async">
          <fs-lpr-source-dropdown-entry
            [providerNameTranslationKey]="'vehicleIntelligence.alprSearch.sourceSelect.vigilant'"
            [provider$]="lprSourceSelectService.vigilantProvider$"
            [isProviderLoaded$]="lprSourceSelectService.isVigilantProviderLoaded$"
            [shouldShowPartialMatches$]="shouldShowPartialMatches$"
            (providerSelectionChange)="providerSelection$.next($event)"
            data-testid="source-dropdown-entry-vigilant"
          >
          </fs-lpr-source-dropdown-entry>

          <div
            *ngIf="
              !(isLastProvider(ViLPRProvider.VIGILANT) | async) &&
              !(lprSourceSelectService.flockProvider$ | async) &&
              !(lprSourceSelectService.flockV3Provider$ | async)
            "
            class="lpr-source-dropdown-entry__provider-group-separator"
          ></div>
        </ng-container>

        <!-- Flock -->
        <ng-container *ngIf="lprSourceSelectService.flockProvider$ | async">
          <fs-lpr-source-dropdown-entry
            [providerNameTranslationKey]="'vehicleIntelligence.alprSearch.sourceSelect.flock'"
            [provider$]="lprSourceSelectService.flockProvider$"
            [shouldShowPartialMatches$]="shouldShowPartialMatches$"
            [isProviderLoaded$]="lprSourceSelectService.isFlockProviderLoaded$"
            (providerSelectionChange)="providerSelection$.next($event)"
            data-testid="source-dropdown-entry-flock"
          ></fs-lpr-source-dropdown-entry>

          <div
            *ngIf="!(isLastProvider(ViLPRProvider.FLOCK) | async)"
            class="lpr-source-dropdown-entry__provider-group-separator"
          ></div>
        </ng-container>

        <!-- Flock V3 -->
        <ng-container *ngIf="lprSourceSelectService.flockV3Provider$ | async">
          <fs-lpr-source-dropdown-entry
            [providerNameTranslationKey]="'vehicleIntelligence.alprSearch.sourceSelect.flockV3'"
            [provider$]="lprSourceSelectService.flockV3Provider$"
            [shouldShowPartialMatches$]="shouldShowPartialMatches$"
            [isProviderLoaded$]="lprSourceSelectService.isFlockV3ProviderLoaded$"
            (providerSelectionChange)="providerSelection$.next($event)"
            data-testid="source-dropdown-entry-flock-v3"
          >
          </fs-lpr-source-dropdown-entry>

          <div
            *ngIf="!(isLastProvider(ViLPRProvider.FLOCK_V3) | async)"
            class="lpr-source-dropdown-entry__provider-group-separator"
          ></div>
        </ng-container>

        <!-- Fusus -->
        <ng-container *ngIf="lprSourceSelectService.fususProvider$ | async">
          <fs-lpr-source-dropdown-entry
            [providerNameTranslationKey]="'common.other'"
            [provider$]="lprSourceSelectService.fususProvider$"
            [shouldShowPartialMatches$]="shouldShowPartialMatches$"
            [isProviderLoaded$]="lprSourceSelectService.isFususProviderLoaded$"
            (providerSelectionChange)="providerSelection$.next($event)"
            data-testid="source-dropdown-entry-fusus"
          >
          </fs-lpr-source-dropdown-entry>

          <div
            *ngIf="!(isLastProvider(ViLPRProvider.FUSUS) | async)"
            class="lpr-source-dropdown-entry__provider-group-separator"
          ></div>
        </ng-container>
      </div>
    </fieldset>
  </ng-container>
</div>
